/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentsSortCriteria {
    getFixupPrototypeFunction() { return AwsSsmListDocumentsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentsSortCriteria>): AwsSsmListDocumentsSortCriteria {
        let obj = Object.assign(new AwsSsmListDocumentsSortCriteria(), model);
        AwsSsmListDocumentsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentsSortCriteria>): AwsSsmListDocumentsSortCriteria {
        if (!model) return null;
        return AwsSsmListDocumentsSortCriteria.newInstance(<AwsSsmListDocumentsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentsSortCriteria) {
        if (!obj) return;

        models.AwsSsmListDocumentsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentsSortCriteria): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AwsSsmListDocumentsSortColumn;

    ascending: boolean;

}
